export const DamageCauseEnum = {
    COLLISION_WITH_VEHICLE: 1,
    COLLISION_WITH_PEDESTRIAN_OR_CYCLIST: 2,
    COLLISION_WITH_STREET_FURNITURE: 3,
    COLLISION_WITH_FIXED_OBJECT: 4,
    COLLISION_WITH_ANIMAL: 5,
    OWN_DEFECT: 6,
    FALLEN_CARGO: 7,
    FIRE: 8,
    SHORT_CIRCUIT: 9,
    PARTIAL_THEFT: 10,
    BURGLARY: 11,
    HAIL: 12,
    STORM: 13,
    LIGHTNING_STRIKE: 14,
    RIOT_VANDALISM: 15,
    EXTERNAL_DISASTER: 16,
    GLASS_BREAKAGE: 17,
    STONE_CHIP: 18,
};
